import React from 'react';
import { BookOpen, FileSpreadsheet, Code, FileText } from 'lucide-react';
import './Services.css';

const servicesData = [
  {
    icon: <BookOpen size={32} />,
    title: 'Poduke iz matematike i fizike',
    description: 'Individualna poduka za učenike osnovnih i srednjih škola. Prilagođen pristup koji pomaže u savladavanju gradiva i pripremi za ispite.',
    highlights: ['Osnovna škola', 'Srednja škola', 'Priprema za ispite', 'Individualni pristup']
  },
  {
    icon: <FileSpreadsheet size={32} />,
    title: 'Osnovna edukacija MS Excel',
    description: 'Naučite osnove rada u MS Excelu - od jednostavnih tablica do naprednih formula. Savršeno za početnike i one koji žele unaprijediti svoje vještine.',
    highlights: ['Osnovne funkcije', 'Formule i izračuni', 'Kreiranje grafikona', 'Praktične vježbe']
  },
  {
    icon: <Code size={32} />,
    title: 'Frontend Development',
    description: 'Stručna edukacija u web razvoju - HTML, CSS, JavaScript i ReactJS. Od osnovnih koncepata do izrade modernih web aplikacija.',
    highlights: ['HTML & CSS', 'JavaScript osnove', 'ReactJS development', 'Praktični projekti']
  },
  {
    icon: <FileText size={32} />,
    title: 'Pisanje životopisa i prijava za posao',
    description: 'Profesionalna pomoć u izradi životopisa i prijava za posao. Povećajte svoje šanse za uspješno zapošljavanje s kvalitetnim dokumentima.',
    highlights: ['Izrada CV-a', 'Motivacijsko pismo', 'LinkedIn profil', 'Savjeti za intervju']
  }
];

const Services = () => {
  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="section-header">
          <span className="section-badge">Naše usluge</span>
          <h2 className="section-title">Usluge prilagođene Vašem uspjehu</h2>
          <p className="section-description">
            Fokus je na kvaliteti i individualnom pristupu svakom klijentu i svakom polazniku.
          </p>
        </div>

        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-highlights">
                {service.highlights.map((highlight, idx) => (
                  <li key={idx}>{highlight}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
